import { makeAutoObservable } from 'mobx';
import { ReportBI } from '../services';
import { ConditionalModalState } from './ConditionalModalState';
import { FieldOperationsBIReporter } from './FieldOperationsBIReporter';
import { FieldArchive } from '../types/FieldsSource';

export interface ArchiveFieldModalStateParams {
  readonly archiver: Pick<FieldArchive, 'archiveField'>;
  readonly reportBi: ReportBI;
}

export class ArchiveFieldModalState {
  readonly biReporter;
  readonly archiver;
  readonly modal;

  constructor(params: ArchiveFieldModalStateParams) {
    this.biReporter = new FieldOperationsBIReporter({
      reportBi: params.reportBi,
    });
    this.archiver = params.archiver;
    this.modal = new ConditionalModalState<{
      id: string;
      origin: string;
      fieldName: string;
      archiveEnabled?: boolean;
    }>({
      onConfirm: async () => {
        if (!this.modal.value) {
          return;
        }

        this.biReporter.reportArchiveFieldModalCtaClicked('Archive');
        await this.archiver.archiveField(
          this.modal.value.id,
          this.modal.value.origin,
        );
      },
      onClose: () => {
        this.biReporter.reportArchiveFieldModalCtaClicked('Cancel');
      },
    });
    makeAutoObservable(this);
  }
}
